var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.6 33",
    style: {
      enableBackground: "new 0 0 37.6 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,10.9L18.8,10.9l4.7-8.2c-2.1-3.6-7.3-3.6-9.4,0L18.8,10.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "12.3,25.6 8,33 29.7,33 25.4,25.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,25.6L28.4,25.6l4.3,7.4c3.8,0,6.2-4.1,4.3-7.4L24.6,4.2l-4.3,7.4L28.4,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,25.6l8.1-13.9L13,4.2L0.7,25.6C-1.2,28.9,1.2,33,5,33L9.3,25.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.8,14.2 13.8,23 23.9,23  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFill);
export default __webpack_public_path__ + "static/media/logo-fill.70bc3063ebde50776e31dee7ee781d64.svg";
export { ForwardRef as ReactComponent };